import { Middleware } from '@reduxjs/toolkit';

export interface actionTypes {
    type?: any
}

export const loggerMiddleware: Middleware = (store) => (next) => (action: actionTypes) => {
    console.group(action.type as any);
    console.log('Dispatching action:', action);
    const result = next(action);
    console.log('Next state:', store.getState());
    console.groupEnd();
    return result;
};